import _get from 'lodash/get';
import _startsWith from 'lodash/startsWith';

export const isOnPage = (location, path, isExact) => {
    const locationPathname = _get(location, 'pathname');
    if (isExact) {
        // match exact path
        return locationPathname === path;
    } else {
        // match the page and all its sub-pages
        return _startsWith(locationPathname, path);
    }
};

export const copyTextToClipboard = async (text, setSnackbarMessage) => {
    if ('clipboard' in navigator) {
        await navigator.clipboard.writeText(text);
    } else {
        document.execCommand('copy', true, text);
    }
    if (setSnackbarMessage) {
        setSnackbarMessage('Copied to Clipboard.');
    }
};
